import { Button, Typography } from 'design-library';

import './UnderConstruction.scss';

export const UnderConstruction = () => {
  return (
    <div
      className="u-construction"
      style={{
        backgroundImage: `url(${
          process.env.PUBLIC_URL + '/images/under-construction.png'
        })`,
      }}
    >
      <Typography variant="h1">Under Construction</Typography>
      <Typography variant="subtitle1">
        We Are Currently Working On This Website
      </Typography>
      <Typography variant="subtitle2">To Deliver</Typography>
      <Typography variant="subtitle2">A Better User Experience</Typography>
      <div className="u-construction-btn">
        <Button>Send</Button>
      </div>
    </div>
  );
};
